import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=7eda4b2c&scoped=true"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQuestions.vue?vue&type=style&index=0&id=7eda4b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda4b2c",
  null
  
)

export default component.exports